export const PRODUCTS = [
  {
    name: "Cardamom",
    tag: "Premium Grade · Kerala Origin",
    img: "https://images.unsplash.com/photo-1758657996330-095d08451cd9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHw0fHxncmVlbiUyMGNhcmRhbW9tJTIwbWFjcm98ZW58MHx8fHwxNzg1NTE0NzYzfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Black Pepper",
    tag: "Bold Aroma · Export Quality",
    img: "https://images.unsplash.com/photo-1649951806971-ad0e00408773?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHw0fHxibGFjayUyMHBlcHBlcmNvcm5zJTIwcGlsZXxlbnwwfHx8fDE3ODU1MTQ3NjN8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Coffee",
    tag: "Plantation Fresh · Arabica & Robusta",
    img: "https://images.unsplash.com/photo-1724514075334-221460871abb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxjb2ZmZWUlMjBiZWFucyUyMG1hY3JvfGVufDB8fHx8MTc4NTUxNDc2M3ww&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Turmeric",
    tag: "High Curcumin Content",
    img: "https://images.unsplash.com/photo-1615485500834-bc10199bc727?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwyfHx0dXJtZXJpYyUyMHBvd2RlciUyMHJvb3RzfGVufDB8fHx8MTc4NTUxNDc2M3ww&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Coconut Products",
    tag: "Virgin Oil · Desiccated Coconut",
    img: "https://images.unsplash.com/photo-1588413335653-34b770bca7c1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHw0fHxjb2NvbnV0JTIwaGFsdmVzJTIwbWluaW1hbHxlbnwwfHx8fDE3ODU1MTQ3NjN8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Banana Chips",
    tag: "Authentic Kerala Taste",
    img: "https://images.unsplash.com/photo-1762884601729-0eeeafbdfb8a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHxiYW5hbmElMjBjaGlwcyUyMHBpbGV8ZW58MHx8fHwxNzg1NTE0Nzc3fDA&ixlib=rb-4.1.0&q=85",
  },
];

export const FEATURES = [
  {
    icon: "Shield",
    title: "Premium Quality",
    body: "Every shipment is sourced from trusted producers and inspected to meet international standards.",
  },
  {
    icon: "Globe",
    title: "Global Export Expertise",
    body: "Reliable logistics, documentation, and coordination for smooth international trade.",
  },
  {
    icon: "Handshake",
    title: "Trusted Partnerships",
    body: "Long-term business relationships built on transparency, consistency, and mutual growth.",
  },
  {
    icon: "Package",
    title: "Customized Supply Solutions",
    body: "Flexible packaging, labeling, private-label manufacturing, and buyer-specific customization.",
  },
];

export const QUALITY_CHECKS = [
  "Verified producer network",
  "Multi-stage quality inspection",
  "Export-grade packaging",
  "Batch traceability",
  "Moisture and quality monitoring",
  "International documentation support",
];

export const MARKETS = [
  "United Arab Emirates",
  "Saudi Arabia",
  "Qatar",
  "Oman",
  "Japan",
  "Malaysia",
  "Thailand",
  "Vietnam",
  "Singapore",
  "Finland",
  "Russia",
  "Europe",
  "United States",
];

export const BUYER_TYPES = [
  "Importers",
  "Wholesalers",
  "Food Manufacturers",
  "Private Label Brands",
  "HORECA",
  "Retail Chains",
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1758910590065-7fc467b0a59e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxjb250YWluZXIlMjBzaGlwJTIwc3VucmlzZSUyMHBvcnR8ZW58MHx8fHwxNzg1NTE0NzYzfDA&ixlib=rb-4.1.0&q=85",
  quality: "https://images.unsplash.com/photo-1700727448575-6f1680cd7d75?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHw0fHxxdWFsaXR5JTIwaW5zcGVjdGlvbiUyMGZhY3Rvcnl8ZW58MHx8fHwxNzg1NTE0NzYzfDA&ixlib=rb-4.1.0&q=85",
  kerala: "https://images.unsplash.com/photo-1658051161493-1d311c4c7b4d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwzfHx0ZWElMjBzcGljZSUyMHBsYW50YXRpb24lMjBrZXJhbGF8ZW58MHx8fHwxNzg1NTE0NzYzfDA&ixlib=rb-4.1.0&q=85",
  logo: "/agraga-logo-full.jpg",
};

export const NAV_LINKS = [
  { label: "About", id: "about" },
  { label: "Products", id: "products" },
  { label: "Quality", id: "quality" },
  { label: "Global Markets", id: "markets" },
  { label: "Contact", id: "contact" },
];

export const FOUNDER = {
  name: "Pramod Mohanachandran Nair",
  title: "Founder & Managing Director",
  company: "AGRAGA VELORA EXPORTS PRIVATE LIMITED",
  portrait: "/founder.jpg",
  lead: "AGRAGA VELORA EXPORTS PRIVATE LIMITED was founded with a simple belief: a company's greatest product is its name.",
  houseStatement: "We are building a house of Indian premium brands that carries the finest products of India to the world with trust, authenticity, and international excellence.",
  pillars: [
    "A globally trusted Indian brand",
    "Premium value for Indian producers",
    "Long-term international relationships",
    "Uncompromising quality & authenticity",
    "India's heritage, meeting modern trade",
  ],
  pullquote: "A single successful transaction creates revenue; a trusted relationship creates a legacy.",
  paragraphs: [
    "We are not building a business that merely exports goods. We are building a global enterprise that connects exceptional products with exceptional markets, and creates long-term relationships founded on trust, quality, and integrity.",
    "India is one of the world's richest sources of agricultural, natural, herbal, and value-added products. From the spice-growing regions of Kerala to the coffee estates of Karnataka, the turmeric fields of Tamil Nadu, the herbal landscapes of the Himalayas, and the diverse agricultural strengths of every state, our vision is to bring the finest products from across India to customers around the world. At the same time, we aspire to build a truly global sourcing and distribution network that enables AGRAGA VELORA to trade, collaborate, and grow across international markets.",
    "We believe the future of global trade belongs to companies that are trusted, transparent, and relentlessly committed to quality. Every product we represent must reflect authenticity, consistency, and professional excellence. Every shipment must reinforce our reputation. Every partnership must be built on reliability and mutual respect.",
    "Our ambition extends beyond spices. We are building a diversified global export platform that includes premium spices, herbs, botanicals, natural ingredients, wellness products, agricultural commodities, food products, and carefully selected value-added products from India and international sourcing partners. Our goal is not to be known for one product, but to be known for one standard: excellence.",
    "AGRAGA VELORA is being built for the long term. We are investing in strong systems, quality assurance, responsible sourcing, modern packaging, transparent documentation, and international compliance because we believe that reputation is earned through consistency.",
    "We do not measure success only by the number of countries we serve. We measure it by the confidence our customers place in us, the reliability of our commitments, and the strength of the relationships we build across continents.",
    "Our vision is to establish AGRAGA VELORA as a globally respected export and trading brand that represents quality, authenticity, professionalism, and enduring value. We want our name to stand for products that buyers can trust, partnerships they can rely on, and a standard they can confidently choose again and again.",
    "To every customer, supplier, partner, and well-wisher who becomes part of this journey, I offer my sincere gratitude. We are committed to earning your trust, honoring our commitments, and building a company whose reputation will travel farther than any shipment we ever send.",
  ],
};

export const BRANDS = [
  {
    key: "agraga",
    name: "AGRAGA",
    tagline: "India's finest origins.",
    accent: "#B08D57",
    heroTitle: "The Finest Grades of India",
    description:
      "Agraga represents our flagship collection of premium agricultural products sourced from India's most respected growing regions. Every product is carefully graded, tested, and prepared for international markets with uncompromising quality standards.",
    story:
      "From the spice hills of Kerala to the coffee estates of Karnataka, Agraga is the house of origin — where provenance, grading, and traceability meet the standards of the world's most discerning buyers.",
    image: "https://images.unsplash.com/photo-1758657996330-095d08451cd9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    categories: [
      { group: "Cardamom", items: ["Reserve", "Signature", "Estate", "Select"] },
      { group: "Black Pepper", items: ["Bold grades", "Premium grades", "Export grades"] },
      { group: "Coffee", items: ["Estate coffees", "Specialty coffees", "Custom buyer grades"] },
      { group: "Future Categories", items: ["White pepper", "Cloves", "Cinnamon", "Nutmeg", "Mace"] },
    ],
    grades: [
      { grade: "Reserve", size: "8mm+", color: "Deep green", moisture: "< 10%", use: "Luxury retail & gifting" },
      { grade: "Signature", size: "7–8mm", color: "Bright green", moisture: "< 11%", use: "Premium retail" },
      { grade: "Estate", size: "6–7mm", color: "Green", moisture: "< 12%", use: "HORECA & wholesale" },
      { grade: "Select", size: "< 6mm", color: "Mixed", moisture: "< 12%", use: "Food manufacturing" },
    ],
  },
  {
    key: "vanshve",
    name: "VANSHVE",
    tagline: "Natural wellness, refined globally.",
    accent: "#1F5C43",
    heroTitle: "Natural Wellness, Refined for the World",
    description:
      "Vanshve is dedicated to wellness, nutrition, and natural living products including bamboo salt, turmeric, virgin coconut oil, cold-pressed oils, herbal products, and value-added wellness collections.",
    story:
      "Rooted in Ayurvedic wisdom and refined for modern living, Vanshve brings India's functional foods and natural nutrition to health-conscious markets worldwide.",
    image: "https://images.unsplash.com/photo-1615485500834-bc10199bc727?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    categories: [
      { group: "Salts & Minerals", items: ["Bamboo salt"] },
      { group: "Turmeric", items: ["Turmeric", "Curcumin products"] },
      { group: "Oils", items: ["Virgin coconut oil", "Cold-pressed coconut oil", "Herbal oils"] },
      { group: "Wellness", items: ["Wellness products", "Functional foods", "Natural nutrition"] },
    ],
  },
  {
    key: "charbelle",
    name: "CHARBELLE",
    tagline: "Botanical beauty from India.",
    accent: "#A97463",
    heroTitle: "Botanical Beauty, Crafted in India",
    description:
      "Charbelle brings together premium personal care and lifestyle products crafted with natural Indian ingredients and contemporary international aesthetics.",
    story:
      "Where Indian botanicals meet contemporary design — Charbelle is skincare and bath rituals composed from nature and finished with international elegance.",
    image: "https://images.unsplash.com/photo-1601049541289-9b1b7bbbfe19?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    categories: [
      { group: "Soaps", items: ["Activated charcoal soap", "Turmeric soap", "Sandal soap", "Herbal soap"] },
      { group: "Skincare", items: ["Botanical skincare", "Hair care"] },
      { group: "Rituals", items: ["Bath collections", "Aromatherapy products"] },
    ],
  },
  {
    key: "artibelle",
    name: "ARTIBELLE",
    tagline: "India's heritage, beautifully crafted.",
    accent: "#9C5A3C",
    heroTitle: "India's Heritage, Beautifully Crafted",
    description:
      "Artibelle celebrates India's artisanal excellence through handicrafts, sustainable home products, bamboo collections, traditional crafts, and GI-tagged heritage products.",
    story:
      "Every Artibelle piece carries the hand of an Indian artisan — heritage crafts and sustainable living objects, made to be treasured across generations.",
    image: "https://images.unsplash.com/photo-1610701596007-11502861dcfa?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    categories: [
      { group: "Heritage Crafts", items: ["Aranmula mirror", "Wooden crafts", "Brass products", "Coconut shell products"] },
      { group: "Sustainable Living", items: ["Bamboo products", "Bamboo tableware", "Natural home products", "Eco-friendly gifting"] },
      { group: "GI-Tagged Collections", items: ["Kerala Collection", "Rajasthan Collection", "Kashmir Collection", "Northeast Collection"] },
    ],
  },
];

export const REGIONS = [
  "Europe",
  "UAE & Gulf",
  "North America",
  "Southeast Asia",
  "East Asia",
  "Australia",
];

export const COLLECTIONS = [
  "Premium Spices",
  "Specialty Coffee",
  "Wellness",
  "Beauty",
  "Heritage Crafts",
  "GI Products",
];

export const COMPLIANCE = [
  { code: "IEC", label: "Import Export Code" },
  { code: "GST", label: "Goods & Services Tax" },
  { code: "FSSAI", label: "Food Safety & Standards" },
  { code: "APEDA", label: "Agricultural Export Authority" },
  { code: "Spice Board", label: "Spices Board of India" },
  { code: "Testing", label: "Independent Quality Testing" },
  { code: "Docs", label: "Full Export Documentation" },
  { code: "Traceability", label: "Batch Traceability" },
  { code: "Verified", label: "Supplier Verification" },
];

export const PACKAGING_OPTIONS = [
  "Retail packs",
  "Bulk export cartons",
  "Vacuum packing",
  "Private label / white label",
  "Custom buyer branding",
];

export const EXPORT_CAPABILITIES = [
  "End-to-end international logistics",
  "Flexible MOQs for new partners",
  "Custom grade & specification sourcing",
  "Consolidated multi-brand shipments",
  "Transparent documentation & communication",
];

export const COMPANY = {
  legalName: "AGRAGA VELORA EXPORTS PRIVATE LIMITED",
  addressLines: [
    "39/2475-B1, Suite M41",
    "L.R. Towers, SJRRA 104",
    "South Janatha Road",
    "Palarivattom, Kochi – 682025",
    "Kerala, India",
  ],
  email: "hello@agragavelora.com",
  website: "www.agragavelora.com",
  whatsapp: "https://wa.me/919999999999",
  linkedin: "https://www.linkedin.com/company/agraga-velora-exports",
};

export const EMBLEM_STORY = [
  {
    symbol: "The Monogram — A · V",
    meaning:
      "AGRAGA (from Sanskrit — 'to lead, to be foremost') and Velora (of Latin-Roman cadence) interlock as one mark: the enduring bond between ancient India and classical Rome, East and West meeting as equals.",
  },
  {
    symbol: "The Crescent",
    meaning:
      "A symbol of continuity and new horizons — every shipment a fresh beginning, carried faithfully across the world's waters.",
  },
  {
    symbol: "The Guiding Star",
    meaning:
      "The north star of dependable trade — direction, clarity, and the trust that lets partners navigate with confidence.",
  },
  {
    symbol: "The Laurel Wreath",
    meaning:
      "Honour and excellence, earned — the classical crown for quality proven again and again, shipment after shipment.",
  },
  {
    symbol: "The Temple Spire",
    meaning:
      "Rooted heritage — the craftsmanship of Indian growers and the sacred discipline of doing things properly.",
  },
];

// Trusted external presence. Replace '#' with real URLs (or manage later).
export const TRUSTED_LINKS = [
  { label: "LinkedIn", icon: "Linkedin", href: "#" },
  { label: "YouTube", icon: "Youtube", href: "#" },
  { label: "Instagram", icon: "Instagram", href: "#" },
  { label: "Alibaba", icon: "ShoppingBag", href: "#" },
  { label: "Google Business", icon: "MapPin", href: "#" },
  { label: "WhatsApp", icon: "MessageCircle", href: "#" },
];

// Featured video. Set `youtubeId` to your video id to embed it inline.
export const FEATURED_VIDEO = {
  youtubeId: "",
  title: "Inside AGRAGA Velora",
  caption: "From the hills of Kerala to the world — a film about our craft.",
};
